export default "__VITE_ASSET__6B10v_XU__"